'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z' });

var VideoLabel = function VideoLabel(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

VideoLabel = (0, _pure2.default)(VideoLabel);
VideoLabel.muiName = 'SvgIcon';

exports.default = VideoLabel;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/VideoLabel.js
// module id = 2978
// module chunks = 0